import { GnrHTMLElement } from "./gnr-element.js";
import * as fUtils from "./gnr-fileUtils.js";
// import { loadComponent } from "./gnr-loader"; // TODO supprimer si effectivement plus besoin -> supprimer tout gnr-loader.js ? 

import scss_component_a_remplir from 'bundle-text:../../components/component-a-remplir/component-a-remplir.scss';
import js_component_a_remplir from 'bundle-text:../../components/component-a-remplir/component-a-remplir.js';
import html_component_a_remplir from 'bundle-text:../../components/component-a-remplir/component-a-remplir.html';
class ComponentARemplir extends GnrHTMLElement{
    async connectedCallback() {
        this.attachShadow({ mode: 'open' });

        this.linkAllComponentFiles(html_component_a_remplir, js_component_a_remplir, scss_component_a_remplir);

        // DOM content loading flags/events
        this.dispatchEvent(new CustomEvent('ShadowDOMContentLoaded', {detail: {class: "ComponentARemplir"} }));
        
        this.readyState = 'interactive';

        // Linking declared HTML attributes from the document to the Component's elements innerHTML/src/other type of content.
        this.linkAllElementsWithId(); 

        ////
        this.readyState = 'complete';
    }

    constructor(){
        super();
    }
}
customElements.define("component-a-remplir", ComponentARemplir);

import scss_portfolio_header from 'bundle-text:../../components/portfolio-header/portfolio-header.scss';
import js_portfolio_header from 'bundle-text:../../components/portfolio-header/portfolio-header.js';
import html_portfolio_header from 'bundle-text:../../components/portfolio-header/portfolio-header.html';
class PortfolioHeader extends GnrHTMLElement{
    async connectedCallback() {
        this.attachShadow({ mode: 'open' });

        this.linkAllComponentFiles(html_portfolio_header, js_portfolio_header, scss_portfolio_header);

        // DOM content loading flags/events
        this.dispatchEvent(new CustomEvent('ShadowDOMContentLoaded', {detail: {class: "PortfolioHeader"} }));
        
        this.readyState = 'interactive';

        // Linking declared HTML attributes from the document to the Component's elements innerHTML/src/other type of content.
        this.linkAllElementsWithId(); 

        ////
        this.readyState = 'complete';
    }

    constructor(){
        super();
    }
}
customElements.define("portfolio-header", PortfolioHeader);